import { Input, Row } from 'antd';
import React from 'react';
import './style.css';

const Price = ({
    min,
    max,
    minValue,
    maxValue,
    onChangeMin,
    onChangeMax,
    title = 'Цена',
}) => {
    const changeValue = (value, type) => {
        if (type === 'min') {
            if (onChangeMin) {
                onChangeMin(value);
            }
        } else if (onChangeMax) {
            onChangeMax(value);
        }
    };
    const checkValue = (type) => {
        let value = type === 'min' ? minValue : maxValue;
        if (value !== '') {
            value = parseInt(value, 10);
            if (type === 'min') {
                if (value > parseInt(maxValue, 10) && maxValue !== '') {
                    value = parseInt(maxValue, 10);
                }
            } else if (value < parseInt(minValue, 10)) {
                value = parseInt(minValue, 10);
            }

            if (value < min) {
                value = min;
            }
            if (value > max) {
                value = max;
            }
            if (type === 'min') {
                if (onChangeMin) {
                    onChangeMin(value);
                }
            } else if (onChangeMax) {
                onChangeMax(value);
            }
        }
    };
    return (
        <Row className="filter-price-container">
            <span className="price-title">{title}</span>
            <Row className="panel-price">
                <Input
                    className="price-input"
                    value={minValue}
                    onBlur={() => checkValue('min')}
                    onChange={(e) => changeValue(e.target.value, 'min')}
                    type="number"
                    placeholder={min?.toLocaleString('ru-RU')}
                    min={min}
                    max={max}
                    allowClear
                    prefix="₽"
                />
                <Input
                    className="price-input"
                    value={maxValue}
                    onBlur={() => checkValue('max')}
                    onChange={(e) => changeValue(e.target.value, 'max')}
                    type="number"
                    placeholder={max?.toLocaleString('ru-RU')}
                    max={max}
                    min={min}
                    allowClear
                    prefix="₽"
                />
            </Row>
        </Row>
    );
};

export default Price;
